import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About - Smartasaurus" },
      { name: "description", content: "Smartasaurus is an endless rabbit hole of curiosity-driven discoveries about the strange, beautiful, and unexplained corners of our world." },
      { property: "og:title", content: "About - Smartasaurus" },
      { property: "og:description", content: "Curiosity-driven science for people who think 'I had no idea that existed.'" },
      { property: "og:url", content: "https://smartasaurus.com/about" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "About - Smartasaurus" },
      { name: "twitter:description", content: "Curiosity-driven science for people who think 'I had no idea that existed.'" },
    ],
    links: [{ rel: "canonical", href: "https://smartasaurus.com/about" }],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main id="main-content" className="mx-auto max-w-3xl px-4 py-20 md:px-8 md:py-28">
        <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-primary">· About</div>
        <h1 className="mt-3 font-display text-5xl uppercase leading-[0.95] md:text-7xl">
          A <span className="text-gradient-curiosity">curiosity company</span>.
        </h1>
        <p className="mt-6 font-display text-xl uppercase leading-tight text-foreground md:text-2xl">
          Understand the world a little better every day.
        </p>
        <div className="mt-10 space-y-6 text-lg leading-relaxed text-muted-foreground">
          <p>
            Smartasaurus is a science-media brand. Not a school. Not a journal. Not a generic facts page.
            The mission is simple: <span className="text-foreground">make people smarter every time they scroll.</span>
          </p>
          <p>
            Most science pages teach. We sell wonder. The audience enters through emotion - surprise, fascination,
            "wait… what?" - and the learning happens afterward. That's the difference.
          </p>
          <p>
            What we cover: weird animals, ocean mysteries, dangerous nature, deep space, the human body,
            evolution, psychology, and the strange edges of future technology. Anything that makes you stop
            scrolling and say it out loud.
          </p>
          <p>
            Built by the team behind Everyday Science - a growing community of curious minds across Instagram,
            TikTok, and the web. Every visit is designed to leave you slightly smarter, slightly more curious,
            and slightly more aware of how strange and fascinating reality actually is.
          </p>
          <p className="text-foreground">
            Welcome to the rabbit hole.
          </p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
